import { render, staticRenderFns } from "./ProAdd.vue?vue&type=template&id=2c9ccd72&scoped=true&"
import script from "./ProAdd.vue?vue&type=script&lang=js&"
export * from "./ProAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProAdd.vue?vue&type=style&index=0&id=2c9ccd72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ccd72",
  null
  
)

export default component.exports